import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '@stockcare-components/shared-components.module';

@NgModule({
  imports: [SharedComponentsModule]
})
export class SharedModule {}
